var App = App || {};

App.ComponentBenefits = (function ($) {
    'use strict';

    function ShowMoreBenefits() {

        $('.component-text .rich-text ul.check').each(function () {

            var $list = $(this);
            var $items = $list.find('li');

            function initBenefits() {

                if ($(window).width() < 768) {

                    if ($items.length <= 2) {
                        return;
                    }

                    $items.slice(2).hide();

                    $list.find('.show-more-wrapper, .show-less-wrapper').remove();

                    $('<li class="show-more-wrapper"><a href="#" class="show-more-link">See more <i class="fa fa-chevron-down" aria-hidden="true"></i></a></li>')
                        .insertAfter($items.eq(1));

                } else {
                    $items.show();
                    $list.find('.show-more-wrapper, .show-less-wrapper').remove();
                }
            }

            // Remove previously attached handlers
            $list.off('click.componentBenefits');

            // Show More
            $list.on('click.componentBenefits', '.show-more-link', function (e) {
                e.preventDefault();

                $items.slice(2).show();

                $(this).closest('.show-more-wrapper').remove();

                $('<li class="show-less-wrapper"><a href="#" class="show-less-link">See less <i class="fa fa-chevron-up" aria-hidden="true"></i></a></li>')
                    .appendTo($list);
            });

            // Show Less
            $list.on('click.componentBenefits', '.show-less-link', function (e) {
                e.preventDefault();

                $items.slice(2).hide();

                $(this).closest('.show-less-wrapper').remove();

                $('<li class="show-more-wrapper"><a href="#" class="show-more-link">See more <i class="fa fa-chevron-down" aria-hidden="true"></i></a></li>')
                    .insertAfter($items.eq(1));
            });

            initBenefits();

            $(window)
                .off('resize.componentBenefits')
                .on('resize.componentBenefits', function () {
                    initBenefits();
                });

        });
    }

    return {
        ShowMoreBenefits: ShowMoreBenefits
    };

})(jQuery);

$(function () {
    App.ComponentBenefits.ShowMoreBenefits();
});